export default import.meta.ROLLDOWN_FILE_URL_K2qjcFyZWmTDXU9Uy6BgHQ